import { GetterTree } from "vuex";
import { Pref, PrefTypeRequest, PrefTypesEnum, SettingsState } from "./types";
import { RootState } from "../types";
import { state } from "../settings";

export const getters: GetterTree<SettingsState, RootState> = {
    getAllPrefTypes: state => state.allPrefTypes,
    getAllIcons: state => state.allIcons,
    getAllGroups: state => state.allGroups,
    getAllPrefs: state => state.allPrefs,
    getSelectedGroup: state => state.selectedGroup,
    getPrefBoolValue: state => ( prefType: PrefTypeRequest ): boolean => {

        let foundPref = _getPref(state, prefType);

        if (foundPref)
        {
            return foundPref.value.toLowerCase() === "true";
        }

        return false;
    },
    getPrefRawValue: state => ( prefType: PrefTypeRequest ): string => {

        let foundPref = _getPref(state, prefType);

        if (foundPref)
        {
            return foundPref.value;
        }

        return "No Pref Found";
    },
    getPref: state => ( prefType: PrefTypeRequest ): Pref => {

        return _getPref(state, prefType);
    }
};

function _getPref(state, prefType: PrefTypeRequest ): Pref {
    let foundPref = state.allPrefs.find(
        pref => pref.prefTypeID == prefType.prefTypeID &&
        pref.groupID == (prefType.groupID == -1 ? null : prefType.groupID)
    );

        if (foundPref)
        {
            return foundPref;
        }

        return undefined;
}
